shadow$provide[176] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
function isTag(_elem) {
  return true;
}
function getChildren(elem) {
  return elem.children || [];
}
function getParent(elem) {
  return elem.parent;
}
function removeSubsets(nodes) {
  const deduped = new Set(nodes);
  deduped.forEach(node => {
    let ancestor = node.parent;
    while (ancestor) {
      if (deduped.has(ancestor)) {
        deduped.delete(node);
        return;
      }
      ancestor = ancestor.parent;
    }
  });
  return Array.from(deduped);
}
const adapter = {isTag, existsOne(test, elems) {
  return elems.some(elem => isTag(elem) ? test(elem) || adapter.existsOne(test, getChildren(elem)) : false);
}, getSiblings(elem) {
  const parent = getParent(elem);
  return parent ? getChildren(parent) : [elem];
}, getChildren, getParent, getAttributeValue(elem, name) {
  if (name === "class") {
    return elem.props.classes.join(" ");
  }
  if (name === "id") {
    return elem.id;
  }
  return "";
}, hasAttrib(elem, name) {
  if (name === "id") {
    return !!elem.id;
  }
  if (name === "class") {
    return elem.props.classes.length > 0;
  }
  if (!elem.traits.hash) {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(elem.traits.hash, name);
}, removeSubsets, getName(elem) {
  var _a;
  return (_a = elem.type) !== null && _a !== void 0 ? _a : "";
}, findOne:function findOne(test, elems) {
  for (const node of elems) {
    if (test(node)) {
      return node;
    } else {
      const match = findOne(test, getChildren(node));
      if (match) {
        return match;
      }
    }
  }
  return null;
}, findAll:function findAll(test, elems) {
  const result = [];
  for (const elem of elems) {
    if (!isTag(elem)) {
      continue;
    }
    if (test(elem)) {
      result.push(elem);
    }
    result.push(...findAll(test, getChildren(elem)));
  }
  return result;
}, getText:function getText(_elem) {
  return "";
},};
const $$default = adapter;

};